import { buildTranscriptPreview } from 'widgets/NoteTaker/utils/buildTranscriptPreview'

export function buildFullTranscriptText(transcript = {}) {
	const direct = String(transcript?.transcriptText || '').trim()
	if (direct) return direct

	const segments = transcript?.transcriptSegments || transcript?.segments || []
	return buildTranscriptPreview(
		segments.map(segment => ({
			...segment,
			chunkId: segment.chunkId ?? segment.chunk_id,
			status: 'final',
		})),
	)
}
